export default __webpack_public_path__ + "static/media/close.dcb6ad93.svg";